/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExperimentResponse
 */
export interface ExperimentResponse {
    /**
     * 
     * @type {number}
     * @memberof ExperimentResponse
     */
    experimentId: number;
    /**
     * 
     * @type {string}
     * @memberof ExperimentResponse
     */
    experimentName: string;
    /**
     * 
     * @type {Date}
     * @memberof ExperimentResponse
     */
    experimentStartTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ExperimentResponse
     */
    experimentEndTime?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExperimentResponse
     */
    groupIds: Array<number>;
}

/**
 * Check if a given object implements the ExperimentResponse interface.
 */
export function instanceOfExperimentResponse(value: object): value is ExperimentResponse {
    if (!('experimentId' in value) || value['experimentId'] === undefined) return false;
    if (!('experimentName' in value) || value['experimentName'] === undefined) return false;
    if (!('groupIds' in value) || value['groupIds'] === undefined) return false;
    return true;
}

export function ExperimentResponseFromJSON(json: any): ExperimentResponse {
    return ExperimentResponseFromJSONTyped(json, false);
}

export function ExperimentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperimentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'experimentId': json['experiment_id'],
        'experimentName': json['experiment_name'],
        'experimentStartTime': json['experiment_start_time'] == null ? undefined : (new Date(json['experiment_start_time'])),
        'experimentEndTime': json['experiment_end_time'] == null ? undefined : (new Date(json['experiment_end_time'])),
        'groupIds': json['group_ids'],
    };
}

export function ExperimentResponseToJSON(json: any): ExperimentResponse {
    return ExperimentResponseToJSONTyped(json, false);
}

export function ExperimentResponseToJSONTyped(value?: ExperimentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'experiment_id': value['experimentId'],
        'experiment_name': value['experimentName'],
        'experiment_start_time': value['experimentStartTime'] == null ? value['experimentStartTime'] : value['experimentStartTime'].toISOString(),
        'experiment_end_time': value['experimentEndTime'] == null ? value['experimentEndTime'] : value['experimentEndTime'].toISOString(),
        'group_ids': value['groupIds'],
    };
}

